module.exports = __webpack_public_path__ + "img/next-topic.ca69e933.png";